module.exports = __webpack_public_path__ + "img/CM-DJ-24-Ford-Modern.108105e6.jpg";